'use-client';
import React from 'react';
import classNames from 'clsx';
import type { MediaContainerVideoAPI } from '@wix/editor-elements-types/components';
import {
  useVideoAPI,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import MeshContainer from '@wix/thunderbolt-elements/src/thunderbolt-core-components/MeshContainer/viewer/MeshContainer';
import FillLayers from '@wix/thunderbolt-elements/src/components/FillLayers/viewer/FillLayers';
import type { SlideShowSlideProps } from '../SlideShowSlide.types';
import styles from './style/SlideShowSlide.scss';

const SlideShowSlide: React.ForwardRefRenderFunction<
  MediaContainerVideoAPI,
  SlideShowSlideProps
> = (props, compRef) => {
  const {
    id,
    className,
    fillLayers,
    children,
    skin,
    meshProps,
    onMouseEnter,
    onMouseLeave,
    getPlaceholder,
    onStop,
  } = props;
  const MeshContainerWithChildren = (
    <MeshContainer id={id} {...meshProps}>
      {children}
    </MeshContainer>
  );

  const hasVideo = !!fillLayers.video;
  const videoRef = useVideoAPI(compRef, hasVideo, onStop);

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, styles.SlideShowSlide)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <FillLayers
        {...fillLayers}
        extraClass={styles.bg}
        getPlaceholder={getPlaceholder}
        videoRef={videoRef}
      />
      <div className={styles.borderNode} />
      {skin === 'StateBoxStateFormSkin' ? (
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          {MeshContainerWithChildren}
        </form>
      ) : (
        MeshContainerWithChildren
      )}
    </div>
  );
};

export default React.forwardRef(SlideShowSlide);
